module.exports = __webpack_public_path__ + "static/media/2.5-hour.7b9f4fa3.png";